import Component from "@glimmer/component"
import styles from "./date-annotations.module.css"

export default class PlannerCardStacksLessonDateAnnotationsComponent extends Component {
  readonly styles = styles
}
